<dx-popup
  [(visible)]="displayDialog"
  [showTitle]="true"
  title="Dupliquer la configuration GEF"
  [width]="500"
  [height]="'auto'"
  (onHidden)="closeDialog()">

  <div *dxTemplate="let data of 'content'">

    <div class="mg-b-10">
      <span class="genlabel">Configuration source : </span>
      <strong>{{ gefConnection?.gefProvider?.code | uppercase }} — {{ gefConnection?.site?.libelle }}</strong>
    </div>

    <div class="dialog-line">
      <div class="label">Sites cibles</div>
      <div class="value">
        <yo-tagbox
          [data]="sitesLocaux"
          [selectedItems]="selectedSiteIds"
          (onValueChange)="selectedSiteIds = $event">
        </yo-tagbox>
      </div>
    </div>

    <div class="d-flex mg-t-15 justify-content-end">
      <yo-button
        class="mg-r-5"
        label="Dupliquer"
        iconClass="fas fa-copy"
        [theme]="ButtonThemeEnum.ADD"
        [disabled]="!selectedSiteIds.length"
        (onClick)="dupliquer()">
      </yo-button>
      <yo-button
        label="Annuler"
        iconClass="fas fa-times"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()">
      </yo-button>
    </div>

  </div>
</dx-popup>
